import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import PropTypes from 'prop-types'
import React from 'react'

export { KeyboardArrowDownIcon }

const SIZES = ['xs', 'sm', 'md', 'lg']

const Icon = ({ alt, color, name, size, ...props }) => (
  <span
    aria-label={alt}
    className={`icon icon-${name} icon-${size}`}
    role="img"
    style={{
      color,
      verticalAlign: 'middle',
    }}
    {...props}
  />
)

Icon.propTypes = {
  alt: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(SIZES),
  color: PropTypes.string,
}

Icon.defaultProps = {
  alt: '',
  size: 'md',
  color: 'brand.color',
}

export default Icon
